/* CRO Panel — picker model
   Server-renders all value stacks. JS toggles which one is active
   and updates ATC variant/price + handles add-to-cart. */

(function () {
  'use strict';

  function CROPanel(root) {
    this.root = root;
    this.cards = root.querySelectorAll('[data-cro-bundle-card]');
    this.stacks = root.querySelectorAll('[data-cro-stack]');
    this.atc = root.querySelector('[data-cro-add-to-cart]');
    this.atcPrice = root.querySelector('[data-cro-cart-price]');
    this.qtyInput = root.querySelector('[data-cro-qty-input]');
    this.qtyDec = root.querySelector('[data-cro-qty-dec]');
    this.qtyInc = root.querySelector('[data-cro-qty-inc]');
    this.toast = root.querySelector('[data-cro-toast]');

    this.bind();
  }

  CROPanel.prototype.bind = function () {
    var self = this;
    this.cards.forEach(function (card) {
      card.addEventListener('click', function () { self.select(card); });
    });
    if (this.atc) {
      this.atc.addEventListener('click', function (e) {
        e.preventDefault();
        self.addToCart();
      });
    }
    // Qty stepper — clamp at 1, no upper limit (cart drawer can adjust further).
    if (this.qtyDec) {
      this.qtyDec.addEventListener('click', function () { self.changeQty(-1); });
    }
    if (this.qtyInc) {
      this.qtyInc.addEventListener('click', function () { self.changeQty(1); });
    }
    this.refreshQtyState();
    // Sync the ATC button to the currently-selected card so the price,
    // variant id, bundle id and gifts always match what's visually selected.
    // Skipped in single-option mode (no cards) — the server-rendered ATC
    // attributes are already correct.
    if (this.cards.length) {
      var initial = null;
      // ?bundle=<handle> wins over the server-rendered preselection. The collection
      // grid links upsell-only combo products ("Parasite Detox + Binder") here rather
      // than to their own undesigned PDP, and this is what opens the panel on the
      // option the shopper actually clicked. Unknown handle → fall through, no throw.
      try {
        var wanted = new URLSearchParams(window.location.search).get('bundle');
        if (wanted) {
          this.cards.forEach(function (c) {
            if (c.getAttribute('data-handle') === wanted) initial = c;
          });
        }
      } catch (e) { /* older browser / bad query string — use the default below */ }
      if (!initial) {
        this.cards.forEach(function (c) {
          if (c.classList.contains('cro-bundle-card--selected')) initial = c;
        });
      }
      if (!initial) initial = this.cards[0];
      this.select(initial);
    }
  };

  CROPanel.prototype.getQty = function () {
    if (!this.qtyInput) return 1;
    var n = parseInt(this.qtyInput.value, 10);
    if (isNaN(n) || n < 1) return 1;
    return n;
  };

  CROPanel.prototype.changeQty = function (delta) {
    if (!this.qtyInput) return;
    var next = Math.max(1, this.getQty() + delta);
    this.qtyInput.value = next;
    this.refreshQtyState();
  };

  CROPanel.prototype.refreshQtyState = function () {
    if (this.qtyDec) this.qtyDec.disabled = this.getQty() <= 1;
  };

  CROPanel.prototype.select = function (card) {
    var idx = card.getAttribute('data-index');
    this.cards.forEach(function (c) {
      var on = c === card;
      c.classList.toggle('cro-bundle-card--selected', on);
      c.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    this.stacks.forEach(function (s) {
      s.classList.toggle('is-active', s.getAttribute('data-cro-stack') === idx);
    });
    if (this.atc) {
      this.atc.setAttribute('data-variant-id', card.getAttribute('data-variant-id'));
      this.atc.setAttribute('data-bundle-id', card.getAttribute('data-handle') || '');
      this.atc.setAttribute('data-gifts', card.getAttribute('data-gifts') || '[]');
      if (this.atcPrice) {
        this.atcPrice.textContent = card.getAttribute('data-price') || '';
      }
    }
  };

  function parseGiftIds(attr) {
    if (!attr) return [];
    try {
      var arr = JSON.parse(attr);
      if (!Array.isArray(arr)) return [];
      return arr.filter(function (id) { return typeof id === 'number' && id > 0; });
    } catch (e) { return []; }
  }

  function getLineProp(item, name) {
    var props = item.properties || {};
    if (Array.isArray(props)) {
      var match = props.find(function (p) { return p[0] === name; });
      return match ? match[1] : null;
    }
    return props[name] || null;
  }

  function cartVariantTotal(cart, variantId) {
    return ((cart && cart.items) || []).reduce(function (n, it) {
      return n + (it.variant_id === variantId ? it.quantity : 0);
    }, 0);
  }

  function addItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      // /cart/add.js is all-or-nothing. On 422, the body has the actual
      // reason (`description`, `errors`, `status`).
      return r.json().then(function (body) {
        if (!r.ok || body.status) {
          var err = new Error(body.description || body.message || 'cart');
          err.shopify = body;
          throw err;
        }
        return body;
      });
    });
  }

  // Set a variant's TOTAL cart quantity via /cart/update.js, verified
  // against a fresh read after the cart settles. This is the ONLY reliable
  // mutation for Simple Bundles kit lines: the backend assigns a fresh
  // line key to every add of the kit (identical adds never merge), and
  // keyed change.js calls against those lines get misapplied as deltas to
  // other lines. update.js rewrites the canonical line; when stale
  // duplicate lines inflate the result we re-ask for less by the
  // overshoot. Throws if the total never lands so the caller can surface
  // a real error.
  function setVariantTotalVerified(variantId, target, attempts, ask) {
    attempts = attempts === undefined ? 3 : attempts;
    if (ask === undefined) ask = target;
    var updates = {};
    updates[variantId] = ask;
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        return new Promise(function (res) { setTimeout(res, 600); });
      })
      .then(function () {
        return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        var total = cartVariantTotal(cart, variantId);
        if (total === target) return cart;
        if (attempts <= 1) throw new Error('Could not update cart quantity. Please try again.');
        var nextAsk = total > target ? Math.max(0, ask - (total - target)) : target;
        return setVariantTotalVerified(variantId, target, attempts - 1, nextAsk);
      });
  }


  CROPanel.prototype.addToCart = function () {
    var self = this;
    if (!this.atc) return;
    var variantId = parseInt(this.atc.getAttribute('data-variant-id'), 10);
    var bundleId = this.atc.getAttribute('data-bundle-id') || '';
    if (!variantId) return;

    if (this.atc.classList.contains('is-loading')) return;
    this.atc.classList.add('is-loading');

    var giftIds = parseGiftIds(this.atc.getAttribute('data-gifts'));

    // De-dupe gifts against current cart: gifts are cart-level singletons.
    // If another bundle already brought the Scoop, we don't add another Scoop.
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var existingGiftVariants = {};
        (cart.items || []).forEach(function (it) {
          var props = it.properties || {};
          var hasGiftProp = Array.isArray(props)
            ? props.some(function (p) { return p[0] === '_bb_gift_for'; })
            : Object.prototype.hasOwnProperty.call(props, '_bb_gift_for');
          if (hasGiftProp) existingGiftVariants[it.variant_id] = true;
        });

        var giftsToAdd = giftIds.filter(function (gid) {
          return !existingGiftVariants[gid];
        });

        var giftItems = giftsToAdd.map(function (gid) {
          return { id: gid, quantity: 1, properties: { '_bb_gift_for': bundleId } };
        });

        // If this bundle is already in the cart, BUMP the variant's total —
        // re-adding never merges (the backend keys every kit add as a new
        // line, see setVariantTotalVerified) and would pile up duplicate
        // qty-1 lines the customer can't see or control.
        var existingParentQty = (cart.items || []).reduce(function (n, it) {
          return n + (it.variant_id === variantId &&
                      getLineProp(it, '_bb_bundle_id') === bundleId ? it.quantity : 0);
        }, 0);
        if (existingParentQty > 0) {
          return setVariantTotalVerified(variantId, cartVariantTotal(cart, variantId) + self.getQty())
            .then(function () { return giftItems.length ? addItems(giftItems) : null; });
        }

        // First add of this bundle. The parent goes in its OWN add.js call —
        // batching it with the gift lines makes the backend hash the parent
        // under a different line key than the one later cart operations
        // target (empirically verified 2026-06-09). Gifts follow separately.
        //
        // Bundle parent stores its own gift list in _bb_gifts so the cart
        // drawer can later determine, on removal, which gifts no other
        // bundle still needs.
        // Quantity scales the bundle line. Gifts stay at qty=1 (cart-level
        // singletons) — buying 3 kits gives 3 sets of jars but still one
        // eBook / one scoop / one ship-protect. (The cart drawer's sweep
        // scales scoop/tracker with total kit qty.)
        return addItems([{
          id: variantId,
          quantity: self.getQty(),
          properties: {
            '_bb_bundle_id': bundleId,
            '_bb_gifts': giftIds.join(','),
            '_bundle_id': bundleId
          }
        }]).then(function () {
          return giftItems.length ? addItems(giftItems) : null;
        });
      })
      .then(function () {
        self.atc.classList.remove('is-loading');
        self.flashToast('Added to cart');
        document.dispatchEvent(new CustomEvent('cart:added', { detail: { silent: false } }));
        document.dispatchEvent(new CustomEvent('bb:cart:open'));
      })
      .catch(function (err) {
        self.atc.classList.remove('is-loading');
        var msg = (err && err.message && err.message !== 'cart')
          ? err.message
          : 'Something went wrong. Please try again.';
        self.flashToast(msg, true);
        if (window.console) console.error('[cro-panel] ATC failed:', err && err.shopify ? err.shopify : err);
      });
  };

  CROPanel.prototype.flashToast = function (msg, isError) {
    if (!this.toast) return;
    this.toast.textContent = msg;
    this.toast.classList.toggle('is-error', !!isError);
    this.toast.classList.add('is-visible');
    var self = this;
    clearTimeout(this._t);
    this._t = setTimeout(function () { self.toast.classList.remove('is-visible'); }, 2200);
  };

  function init() {
    document.querySelectorAll('[data-cro-panel]').forEach(function (el) {
      if (el.__croInit) return;
      el.__croInit = true;
      new CROPanel(el);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
